package devxertech.com.section

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.A

@Composable
fun DesktopNavigationLink(path: String, text: String, modifier: Modifier) {
    DesktopNavigationAnchor(path, modifier) { SpanText(text) }
}

@Composable
fun DesktopNavigationAnchor(path: String, modifier: Modifier, content: @Composable () -> Unit) {
    val ctx = rememberPageContext()
    A(
        attrs = modifier.attrsModifier { attr("href", path) }
            .styleModifier { property("text-decoration", "none") }
            .onDesktopNavigationClick { ctx.router.navigateTo(path) }
            .toAttrs()
    ) {
        content()
    }
}

fun Modifier.onDesktopNavigationClick(navigate: () -> Unit): Modifier = onClick { event ->
    if (event.button.toInt() == 0 && !event.ctrlKey && !event.metaKey &&
        !event.shiftKey && !event.altKey
    ) {
        event.preventDefault()
        navigate()
    }
}
